import { createSelector } from 'reselect';
import { createErrorDataSelector } from 'selectors/selectorUtils';

const getAssetInfo = ({ sensorProperties }) => {
	return sensorProperties.assetInfo;
};

const getSensorFeatures = ({ sensorProperties }) => {
	return sensorProperties.sensorFeatures;
};

const getSensorProperties = ({ sensorProperties }) => {
	return sensorProperties.sensorProperties;
};

const getSensorGatewayInfo = ({ sensorProperties }) => {
	return sensorProperties?.sensorGatewayInfo;
};

const getSensorTypeId = ({ sensorProperties }) => {
	return sensorProperties?.sensorProperties?.data?.sensorTypeId;
};

const getGatewayInfo = ({ sensorProperties }) => {
	return sensorProperties.gatewayInfo;
};
const getTimeseriesInfo = ({ sensorProperties }) => {
	return sensorProperties?.sensorTimeseriesInfo;
};
const getRssiValue = ({ sensorProperties }) => {
	return sensorProperties.sensorRssiValue;
};

const getSensorBatteryLevelData = ({ sensorProperties }) => {
	return sensorProperties.sensorBatteryLevel;
};

const getAssetDetails = ({ detailedInformation }) => {
	return {
		loadingStatus: detailedInformation.assetDetails.loadingStatus,
		details: detailedInformation.assetDetails.data?.details
	};
};

const getSensorPropertiesError = ({ sensorProperties }) => {
	return {
		loadingStatus: sensorProperties?.sensorProperties?.loadingStatus,
		error: sensorProperties?.sensorProperties?.error,
		errorCode: sensorProperties?.sensorProperties?.error?.statusCode
	};
};

const getSensorGatewayInfoError = ({ sensorProperties }) => {
	return {
		loadingStatus: sensorProperties?.sensorGatewayInfo?.loadingStatus,
		error: sensorProperties?.sensorGatewayInfo?.error,
		errorCode: sensorProperties?.sensorGatewayInfo?.error?.statusCode
	};
};

const getSensorBatteryLevelError = ({ sensorProperties }) => {
	return {
		loadingStatus: sensorProperties?.sensorBatteryLevel?.loadingStatus,
		error: sensorProperties?.sensorBatteryLevel?.error,
		errorCode: sensorProperties?.sensorBatteryLevel?.error?.statusCode
	};
};

// Memoized selectors for sensor properties error data
const getSensorPropertiesErrorData = createErrorDataSelector(getSensorPropertiesError);
const getSensorGatewayInfoErrorData = createErrorDataSelector(getSensorGatewayInfoError);
const getSensorBatteryLevelErrorData = createErrorDataSelector(getSensorBatteryLevelError);

export const getModel = createSelector([
	getAssetInfo,
	getSensorProperties,
	getSensorGatewayInfo,
	getSensorFeatures,
	getSensorTypeId,
	getGatewayInfo,
	getTimeseriesInfo,
	getRssiValue,
	getAssetDetails,
	getSensorBatteryLevelData,
	getSensorPropertiesErrorData,
	getSensorGatewayInfoErrorData,
	getSensorBatteryLevelErrorData
], (
	assetInfo,
	sensorProperties,
	sensorGatewayInfo,
	sensorFeatures,
	sensorTypeId,
	gatewayInfo,
	timeseriesInfo,
	rssiValue,
	assetDetails,
	sensorBatteryLevel,
	sensorPropertiesErrorData,
	sensorGatewayInfoErrorData,
	sensorBatteryLevelErrorData
) => {
	return {
		assetInfo,
		sensorProperties,
		sensorGatewayInfo,
		sensorFeatures,
		sensorTypeId,
		gatewayInfo,
		timeseriesInfo,
		rssiValue,
		assetDetails,
		sensorBatteryLevel,
		sensorPropertiesErrorData,
		sensorGatewayInfoErrorData,
		sensorBatteryLevelErrorData
	};
});


